import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import styles from './Accordion.module.css';

export interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  badge?: string | number;
  rightContent?: React.ReactNode;
  className?: string;
}

export const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  defaultExpanded = false,
  badge,
  rightContent,
  className = '',
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={`${styles.accordion} ${className}`}>
      <button
        type="button"
        className={styles.header}
        onClick={toggleExpanded}
        aria-expanded={isExpanded}
      >
        <div className={styles.headerLeft}>
          <span className={styles.chevron}>
            {isExpanded ? (
              <ChevronDown size={16} />
            ) : (
              <ChevronRight size={16} />
            )}
          </span>
          <span className={styles.title}>{title}</span>
          {badge !== undefined && (
            <span className={styles.badge}>{badge}</span>
          )}
        </div>
        {rightContent && (
          <div className={styles.headerRight} onClick={(e) => e.stopPropagation()}>
            {rightContent}
          </div>
        )}
      </button>
      {isExpanded && (
        <div className={styles.content}>
          {children}
        </div>
      )}
    </div>
  );
};
